import React from "react";

/**
 * Compact step indicator for mobile: dots + line, current step label only.
 * Avoids cramming 4 long labels in one row on small screens.
 */
const ProgressBar = ({ currentStep, totalSteps, labels = [] }) => {
  const currentLabel = labels[currentStep - 1];

  return (
    <div className="w-full">
      {/* Compact: step dots + progress line */}
      <div className="flex items-center gap-1 sm:gap-2">
        {Array.from({ length: totalSteps }, (_, i) => i + 1).map((stepNum) => (
          <React.Fragment key={stepNum}>
            <div
              className={`flex-shrink-0 w-8 h-8 sm:w-9 sm:h-9 rounded-full flex items-center justify-center text-xs font-bold transition-colors duration-150 ${
                stepNum < currentStep
                  ? "bg-emerald-500 text-white"
                  : stepNum === currentStep
                    ? "bg-red-600 text-white ring-2 ring-red-300 ring-offset-2"
                    : "bg-slate-200 text-slate-500"
              }`}
            >
              {stepNum}
            </div>
            {stepNum < totalSteps && (
              <div className="flex-1 h-1 min-w-[8px] rounded-full bg-slate-200 overflow-hidden">
                <div
                  className="h-full bg-emerald-500 rounded-full transition-colors duration-150 ease-out"
                  style={{
                    width:
                      currentStep > stepNum ? "100%" : currentStep === stepNum ? "50%" : "0%",
                  }}
                />
              </div>
            )}
          </React.Fragment>
        ))}
      </div>
      {/* Current step label only — saves space on mobile */}
      <div className="mt-2 text-center min-h-[2rem]">
        <span className="text-xs font-medium text-slate-500">
          {currentStep} / {totalSteps}
        </span>
        {currentLabel && (
          <p className="text-sm font-semibold text-slate-800 mt-0.5 line-clamp-2">
            {currentLabel}
          </p>
        )}
      </div>
    </div>
  );
};

export default ProgressBar;
